import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ValidatorFn, Validators } from '@angular/forms';
import {EmailTemplateService} from '../../../services';
import { EmailTemplate } from 'src/app/admin/models';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import {EditorModule} from 'primeng/editor';
import { SharedService } from '../../../../shared/services/shared.service';

@Component({
  selector: 'app-email-template-add',
  templateUrl: './email-template-add.component.html',
  styleUrls: ['./email-template-add.component.css']
})
export class EmailTemplateAddComponent implements OnInit {
  emailTemplateAddForm:FormGroup;
  tempid: number =0;
  constructor(private emailTemplateService:EmailTemplateService,
    private router: Router,private route: ActivatedRoute,
    private _fb: FormBuilder,
    public sharedService: SharedService
    ) { }

  ngOnInit(): void {
    this.checkViewPermission();
    this.InitialSetup();
    this.route.queryParams
      .subscribe(params => {
        console.log(params);
        this.tempid = params.id;
        console.log("id value is "+this.tempid);
      }
    );

    if(this.tempid>0)
    {
      this.emailTemplateService.getEmailTemplateById(this.tempid).subscribe((data:EmailTemplate) =>{
      this.emailTemplateAddForm.patchValue(data);
      },error => {
         console.log(error)
       })
    }
  }
  
  checkViewPermission()
  {
    var result = this.sharedService.checkPermission("Admin_View");
    if(!result)
    this.router.navigateByUrl('/login');
  }
  
  InitialSetup(){
    this.emailTemplateAddForm = this._fb.group({
      templateId: new FormControl(0,[Validators.required]),
      templateName: new FormControl("",[Validators.required]),
      screenName:new FormControl("",[Validators.required]),
      subject:new FormControl("",[Validators.required]),
      //description: new FormControl("",[Validators.required, this.editorMaxLength(10000)]),
      description: new FormControl("",[Validators.required]),
      isActive: new FormControl(false,[Validators.required]),
      createdBy: new FormControl(""),
      createdOn: new FormControl(""),
      modifiedBy: new FormControl(""),
      modifiedOn: new FormControl("")
    })
  }
  
  editorMaxLength(maxlength): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      var regex = /(<([^>]+)>)/ig;
      var value = control.value;
      if (value == null) {
        return null;
      }
      var result = value.replace(regex, "");
      if (result.length > maxlength) {
        return { 'maxlengthError': true };
      }else{
        return null;
      }
    }
  }
  
  save({value}: {value: EmailTemplate}){
    console.log(value);
    //if(value.TemplateId == 0){
    if(this.tempid==undefined){
      value.createdBy = 1;
      value.createdOn = new Date();
      value.Description=this.emailTemplateAddForm.get('description').value.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;/g, " ");
      this.emailTemplateService.postEmailTemplate(value).subscribe(data => {
        this.router.navigate(['/email-template']);
      }, error => {
        console.log(error)
      })
    }else{
      value.TemplateId=this.tempid;
      value.Description=this.emailTemplateAddForm.get('description').value.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;/g, " ");
      this.emailTemplateService.updateEmailTemplate(value.TemplateId, value).subscribe(data => {
        this.router.navigate(['/email-template']);
      }, error => {
      console.log(error);
      })
    }
  }

  cancel()
  {
    this.router.navigate(['/email-template']);
  }

}
